// 공통 포맷 헬퍼.

import type { CredentialType } from '../api/types';

export function typeLabel(t: CredentialType): string {
  switch (t) {
    case 'account': return '계정';
    case 'api_key': return 'API 키';
    case 'server': return '서버';
    case 'env': return '환경변수';
    case 'auth': return '인증';
  }
}

export function typeIcon(t: CredentialType): string {
  switch (t) {
    case 'account': return '👤';
    case 'api_key': return '🔑';
    case 'server': return '🖥️';
    case 'env': return '📋';
    case 'auth': return '🛡️';
  }
}

export function formatDate(ms: number): string {
  const d = new Date(ms);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function formatDateTime(ms: number): string {
  const d = new Date(ms);
  const date = formatDate(ms);
  const h = String(d.getHours()).padStart(2, '0');
  const mi = String(d.getMinutes()).padStart(2, '0');
  return `${date} ${h}:${mi}`;
}

export function daysUntil(ms: number): number {
  const diff = ms - Date.now();
  return Math.max(0, Math.ceil(diff / (24 * 60 * 60 * 1000)));
}

/** YYYY-MM-DD → unix ms (로컬 자정). 실패 시 null. */
export function parseDateInput(value: string): number | null {
  if (!value) return null;
  const [y, m, d] = value.split('-').map((s) => Number(s));
  if (!y || !m || !d) return null;
  const dt = new Date(y, m - 1, d);
  return dt.getTime();
}

/** unix ms → date input 값(YYYY-MM-DD). */
export function toDateInput(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return '';
  return formatDate(ms);
}
